import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import service from '@/services/index';
import { usePopup } from '@/stores/pure/PopupStore';

const useDashboardActions = () => {
  const wr = useWorkspaceRouter();
  const setPopup = usePopup();
  const [searchParams] = useSearchParams();

  const createDashboard = useCallback(
    async (dashboardName: string, callback?: () => void) => {
      try {
        const folder_alias = searchParams.get('folder_alias');
        if (folder_alias) {
          const { alias: dashboardAlias } =
            await service.dashboard2.createDashboardInFolder(
              folder_alias,
              dashboardName,
            );
          await callback?.();
          wr.push(`/dashboard2/${dashboardAlias}`);
        } else {
          const { alias: dashboardAlias } =
            await service.dashboard2.createDashboard(dashboardName);
          await callback?.();
          wr.push(`/dashboard2/${dashboardAlias}`);
        }
      } catch (e: unknown) {
        setPopup({
          popupTheme: 'negative',
          title: 'Dashboard creation failed',
          message:
            'An error occurred while creating the dashboard. Please try again later.',
          type: 'alert',
        });
      }
    },
    [searchParams, setPopup, wr],
  );

  return {
    createDashboard,
  };
};

export default useDashboardActions;
